import ScrollReveal from "./ScrollReveal";
import { ArrowRight, Check } from "lucide-react";

export default function PricingSection() {
  return (
    <section id="tarifs" data-testid="pricing-section" className="py-24 lg:py-36 bg-[#0284FC]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <ScrollReveal>
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white mb-4">
              Des solutions accessibles
            </h2>
            <p className="text-base sm:text-lg text-white/70 leading-relaxed max-w-2xl mx-auto">
              Une cuisine neuve coûte souvent entre{" "}
              <span className="font-bold text-white">10 000&euro; et 15 000&euro;</span>.
              Avec Vinylux, transformez la vôtre pour une fraction du prix.
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <div className="max-w-lg mx-auto">
            <div
              data-testid="pricing-card"
              className="bg-white rounded-3xl p-8 lg:p-10 shadow-2xl shadow-black/10 text-center"
            >
              <div className="inline-flex items-center gap-2 bg-[#0284FC]/10 text-[#0284FC] px-4 py-1.5 rounded-full text-sm font-semibold mb-6">
                Rénovation complète
              </div>
              <div className="mb-2">
                <span className="font-heading font-black text-5xl lg:text-6xl text-[#0284FC]">
                  2 500
                </span>
                <span className="font-heading font-bold text-2xl text-[#0284FC]/40 ml-1">
                  &euro;
                </span>
              </div>
              <p className="text-[#0284FC]/50 text-sm mb-8">à partir de</p>

              <ul className="space-y-3 text-left mb-8">
                {[
                  "Revêtement de toutes les façades",
                  "Matériaux professionnels durables",
                  "Pose incluse (environ 2 jours)",
                  "Devis gratuit et personnalisé",
                  "Garantie sur la pose",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <div className="w-5 h-5 rounded-full bg-[#0284FC] flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check className="w-3 h-3 text-white" strokeWidth={3} />
                    </div>
                    <span className="text-[#0284FC]/80 text-sm font-medium">{item}</span>
                  </li>
                ))}
              </ul>

              <p className="text-[#0284FC]/40 text-xs mb-6">
                Chaque projet est unique — devis gratuit et personnalisé
              </p>

              <a
                href="#contact"
                data-testid="pricing-cta"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-flex items-center justify-center gap-2 w-full bg-[#0284FC] hover:bg-[#026ECE] text-white font-bold px-8 py-4 rounded-full transition-all hover:scale-105 text-base"
              >
                Obtenir mon devis gratuit en 24h
                <ArrowRight className="w-5 h-5" />
              </a>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
